
const EstimateRentPricing = () =>
  import('~/components/Car/EstimateRentPricing.vue');
const CarContract = () => import('~/components/Car/CarContract.vue');
export default {
  components: { EstimateRentPricing, CarContract },
};
